import { Modal, Form, Input, Checkbox, message, Select, Empty, Col, Tooltip, Spin, Row  } from 'antd';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { MyButton, MyText } from '../../common';
import { StyledSelect } from './style';
import { QuestionCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import { fetchRegionsAction, fetchKindergartensAction, fetchCreateApplicationAction, resetCreateApplicationAction} from '../../../utils';
import InputMask from "react-input-mask";
import { PhoneOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { RootState, selectStore } from '../../../utils';
import { useSelector } from 'react-redux';
import { ConsultSuccessIcon } from '../../../assets/icon/common/header';
import { useEmbeddedNavigate } from '../../../utils/context/embed';

interface ConsultationFormModalProps {
  visible: boolean;
  selectedItem: any;
  specialists: any;
  canSelectSpecialist: any;
  onOk: () => void;
  onCancel: () => void;
  childInfo?: { name?: string; birth_date?: string; age?: string | number; gender?: string } | null;
  diagnosticResult?: {
    date: string;
    ageKey: string;
    questions: { question: string; answer: 'yes' | 'no' | null }[];
    yesCount: number;
    totalCount: number;
    resultTitle: string;
  } | null;
  diaryWeekName?: any;
  diaryTable?: any[];
  showAutoInfoNote?: boolean;
}

export const ConsultationFormModal: React.FC<ConsultationFormModalProps> = ({
  visible, specialists, selectedItem, canSelectSpecialist, onOk, onCancel,
  childInfo, diagnosticResult, diaryWeekName, diaryTable, showAutoInfoNote,
}) => {
  const [form] = Form.useForm();
  const {t} = useTranslation("common")
  const { Option } = Select;
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  // const [isLoading, setIsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedSpecialist, setSelectedSpecialist] = useState(null);
  const [selectedOrganizationInfo, setSelectedOrganizationInfo] = useState(null);
  const createApplication = useSelector((state: any) => state.materials?.createApplication ?? { loading: false });

  // const [regions, setRegions] = useState([]);
  const [phone, setPhone] = useState('');
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const [profileData, setProfileData] = useState(null);
  const [regionData, setRegionData] = useState(null);
  const [kindergartens, setKindergartens] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [noKindergarten, setNoKindergarten] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [prevRegionId, setPrevRegionId] = useState<number | null>(null);
  const [showSuccess, setShowSuccess] = useState(false);  

  const {articles: {regions: regionsState}} = useSelector(selectStore)
  const { profile: { userData: userDataState}}: RootState = useSelector(selectStore);
  const {articles: {kindergartens: kindergartensState}} = useSelector(selectStore)


  const [formData, setFormData] = useState({
    name: userDataState?.data?.first_name || '',
    phone: '',
    organizationInfo: null,
    // region: null,
    // settlement: null,
    specialist: null,
    message: '',
  });
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();

  useEffect(() => {
  const { organizationInfo, phone, message, specialist } = formData;
  const isValidPhone = phone.length === 18;

  const isFormComplete =
    isValidPhone &&
    message &&
    (noKindergarten || organizationInfo) &&
    (!canSelectSpecialist || specialist);

  setIsButtonDisabled(!isFormComplete);
}, [formData, phone, canSelectSpecialist, noKindergarten]);

  const handleInputChange = (field: string, value: string | boolean) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (!createApplication.success) return;
    form.resetFields();
    setFormData({ name: "", message: "", phone: "", organizationInfo: null, specialist: null });
    setError(null);
    setShowSuccess(true);
  }, [createApplication.success]);

  const handleCloseSuccess = () => {
    dispatch(resetCreateApplicationAction());
    setShowSuccess(false);
    onCancel();
  };

  useEffect(() => {
    if (visible) {
      setShowSuccess(false);
    }
  }, [visible]);

  const handleRegionChange = (value: any) => {
    setSelectedRegion(value);
    setFormData((prev) => ({ ...prev, region: value }));
    setSelectedCity(null);
  };

  const handleCancel = () => {
  form.resetFields();
  setFormData({ name: "", message: "", phone: "", organizationInfo: null, specialist: null });
  setError(null);
  onCancel();
};

const handleCancelAndNavigate = () => {
  handleCancel();
  embeddedNavigate('/profile');
};
  const handleCityChange = (value: any) => {
    setSelectedCity(value);
    setFormData((prev) => ({ ...prev, settlement: value }));
  };

  const handleSpecialistChange = (value: any) => {
    setSelectedSpecialist(value);
    setFormData((prev) => ({ ...prev, specialist: value }));
  };

   const handleSelectedOrganizationChange = (value: any) => {
    setSelectedOrganizationInfo(value);
    setFormData((prev) => ({ ...prev, organizationInfo: value }));
  };


  useEffect(() => {
    if (userDataState?.data?.first_name) {
      setFormData((prev) => ({
        ...prev,
        name: userDataState.data.first_name,
      }));
    }
  }, [userDataState]);


  const hasFilledDiaryData = (diaryTable?: any[]) =>
  !!diaryTable?.some(
    (row) =>
      row.words !== '–' ||
      row.gestures !== '–' ||
      row.understood !== '–' ||
      row.activity !== '–' ||
      row.comment !== '–'
  );

  const buildProblemText = (
    userMessage: string,
    childInfo?: ConsultationFormModalProps['childInfo'],
    diagnosticResult?: ConsultationFormModalProps['diagnosticResult'],
    diaryWeekName?: any,
    diaryTable?: any[]
  ) => {
    const diaryHasData = hasFilledDiaryData(diaryTable);
    const hasExtraInfo = !!diagnosticResult || diaryHasData;

    if (!hasExtraInfo) {
      return userMessage;
    }

    const parts: string[] = [`Вопрос: ${userMessage}`];

    if (childInfo) {
      parts.push(
        [
          '--- Информация о ребёнке ---',
          childInfo.name ? `Имя: ${childInfo.name}` : null,
          childInfo.birth_date ? `Дата рождения: ${childInfo.birth_date}` : null,
          childInfo.age ? `Возраст: ${childInfo.age}` : null,
          childInfo.gender ? `Пол: ${childInfo.gender}` : null,
        ]
          .filter(Boolean)
          .join('\n')
      );
    }

    if (diagnosticResult) {
      const questionsText = diagnosticResult.questions
        .map((q, i) => `${i + 1}. ${q.question} — ${q.answer === 'yes' ? 'Да' : q.answer === 'no' ? 'Нет' : '—'}`)
        .join('\n');

      parts.push(
        [
          '--- Результаты диагностики речевого развития ---',
          `Дата прохождения: ${new Date(diagnosticResult.date).toLocaleDateString('ru-RU')}`,
          `Итог: ${diagnosticResult.yesCount}/${diagnosticResult.totalCount} «Да» — ${diagnosticResult.resultTitle}`,
          questionsText,
        ].join('\n')
      );
    }

    if (diaryHasData) {
      const weekLine = diaryWeekName ? `Неделя марафона: ${diaryWeekName}` : null;
      const tableText = diaryTable!
        .map(
          (row) =>
            `${row.day}: слова/звуки — ${row.words}; жесты/действия — ${row.gestures}; ` +
            `понял инструкции — ${row.understood}; активность — ${row.activity}; комментарий — ${row.comment}`
        )
        .join('\n');

      parts.push(
        ['--- Таблица наблюдений ---', weekLine, tableText].filter(Boolean).join('\n')
      );
    }

    return parts.join('\n\n');
  };

  const handleButtonClick = () => {
    const phoneValue = phone.replace(/\D/g, "");
    const specialistId = canSelectSpecialist
      ? selectedSpecialist
      : specialists.find(s => s.name === selectedItem.label)?.id || null;

    const problemText = buildProblemText(
      formData.message,
      childInfo,
      diagnosticResult,
      diaryWeekName,
      diaryTable
    );

    dispatch(fetchCreateApplicationAction({
      name: userDataState?.data?.first_name || formData.name,
      specialist_type: specialistId,
      city_id: userDataState?.data?.region_id,
      contact_value: phoneValue,
      problem_text: problemText,
      ...(!noKindergarten && { organization_id: selectedOrganizationInfo }),
    }));
  };


  useEffect(() => {
    if (!createApplication.failed || !createApplication.data?.errors) return;
    setError(createApplication.data.errors);
  }, [createApplication.failed]);

  const isLoading = createApplication.loading;
  const handleSearch = (value: string) => {
    setSearchValue(value);
    if (searchTimeout) clearTimeout(searchTimeout);

    const timeout = setTimeout(() => {
      const regionId = userDataState?.data?.region_id;
      if (!regionId) return;

      dispatch(fetchKindergartensAction({
        region_id: regionId,
        search: value,
      } as any));
    }, 500);

    setSearchTimeout(timeout);
  };

  return (
    <Modal
      open={visible}
      onOk={onOk}
      onCancel={showSuccess ? handleCloseSuccess : handleCancel}
      footer={null}
      centered
      width={showSuccess ? 480 : 520}
    >
      {showSuccess ? (
      <div style={{ textAlign: 'center' }}>
        <ConsultSuccessIcon style={{ marginBottom: 35, marginTop: 15 }} />
        <MyText color="#0A033C" size={26} weight={800} style={{ fontFamily: 'Nunito', display: 'block', textAlign: 'center', marginBottom: 16 }}>
          {t("applicationSent")}
        </MyText>
        <MyText color="#0A033C" size={18} weight={400} style={{ fontFamily: 'Nunito', display: 'block', textAlign: 'center', marginBottom: 24 }}>
          {t("specialistContact")}
        </MyText>
        <MyButton color="orange" type="primary" onClick={handleCloseSuccess}>
          {t("close")}
        </MyButton>
      </div>
    ) : (
      <>
      
      <Col span={24} style={{marginTop: 22}}>
      <MyText color='#0A033C' size={32} weight={800} style={{ fontFamily: 'Nunito' }}>
      {`${t("getConsultation")}`}
      </MyText>
      </Col>
      
      <Form form={form} layout="vertical" name="consultationForm">
        <Col style={{marginTop: 25, marginBottom: 15}}>
        {userDataState?.data?.last_name && userDataState?.data?.first_name && (
            <>
              <MyText color='#0A033C' size={18} weight={800} style={{ fontFamily: 'Nunito', marginRight: 5 }}>
              {userDataState.data.last_name} {userDataState.data.first_name}
              </MyText>
              <Tooltip title={t("editFullName")}>
                <QuestionCircleOutlined
                  style={{ color: '#A3AED0', fontSize: 18, cursor: 'pointer', marginRight: 5 }}
                  onClick={handleCancelAndNavigate}
                />
              </Tooltip>
            </>
          )}
          <MyText color='#0A033C' size={18} weight={600} style={{ fontFamily: 'Nunito', lineHeight: "32px" }}>
          {/* {t("specialist")} */}
         {t("consultText")}
          </MyText>
        </Col>

        <Form.Item style={{ marginBottom: 5 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {`${t("phone")}`}
          </MyText>
        </Form.Item>
        <Form.Item
          name="phone"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message: t("pleaseEnterPhoneNumber") }]}
        >

          <InputMask
              mask="+7 (799) 999-99-99"
              value={phone}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/\D/g, "").slice(1, 11);
                const formattedPhone = `+7 (${rawValue.slice(0, 3)}) ${rawValue.slice(3, 6)}-${rawValue.slice(6, 8)}-${rawValue.slice(8, 10)}`;
                setPhone(formattedPhone);

                setFormData((prev) => ({ ...prev, phone: formattedPhone }));
              }}
              maskChar=""
            >
                        {(inputProps) => (
                          <Input
                            {...inputProps}
                            name="phone"
                            prefix={<PhoneOutlined style={{ color: "#969BAB", marginRight: 8 }} />}
                            placeholder="+7 (777) 777-77-77"
                          />
                        )}
                      </InputMask>
        </Form.Item>

        <Form.Item style={{ marginBottom: 5, marginTop: 15 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {t("preschoolInfo")}
          </MyText>
        </Form.Item>
        <Form.Item
          name="organizationInfo"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message: t("selectFromList") }]}
        >
          <StyledSelect
            showSearch
            placeholder={t("selectFromList")}
            style={{ width: '100%', height: 52 }}
            value={selectedOrganizationInfo}
            onChange={handleSelectedOrganizationChange}
            onSearch={handleSearch}
            notFoundContent={loading ? <Spin size="small" /> : <Empty imageStyle={{ height: 80 }} description={t("noData")} />}
            disabled={noKindergarten}
            filterOption={false}
          >
                        {kindergartensState?.data?.kindergartens && kindergartensState?.data?.kindergartens.map((specialist) => (
                              <Option key={specialist.id} value={specialist.id}>
                                  {specialist.name}
                              </Option>
                          ))}
           
                      </StyledSelect>
        </Form.Item>
        <Form.Item style={{ marginBottom: 6 }}>
                  <Checkbox checked={noKindergarten} onChange={(e) => setNoKindergarten(e.target.checked)}>
                     <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
                      {t("myChildDoesNotAttend")}
                      </MyText>
                  </Checkbox>
                </Form.Item>
{ canSelectSpecialist && (
<>
<Form.Item style={{ marginBottom: 5, marginTop: 15 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {t("specialist")}
          </MyText>
        </Form.Item>
        <Form.Item
          name="specialist"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message: t("selectFromList") }]}
        >
          <StyledSelect
                          placeholder={t("selectFromList")}
                          style={{ width: '100%', height: 52 }}
                          value={selectedSpecialist}
                          onChange={handleSpecialistChange}
                          notFoundContent={<Empty imageStyle={{ height: 80 }} description={t("noData")} />}
                      >
                        {specialists && specialists.map((specialist) => (
                              <Option key={specialist.id} value={specialist.id}>
                                  {specialist.name}
                              </Option>
                          ))}
           
                      </StyledSelect>
        </Form.Item>
        </>
)
}
        <Form.Item style={{ marginBottom: 5 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {`${t("text")}`}
          </MyText>
        </Form.Item>
        
        <Form.Item
          name="message"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message:  t("pleaseDescribeYourProblem") }]}
          validateStatus={error?.problem_text ? "error" : ""}
          help={error?.problem_text}
        >
          <Input.TextArea
            rows={4}
            placeholder={`${t("describeYourIssue")}`}
            style={{
              height: 127,
              resize: 'none',
            }}
            onChange={(e) => handleInputChange('message', e.target.value)}
          />
        </Form.Item>

      {showAutoInfoNote && (
          <Row
            wrap={false}
            align="top"
            style={{
              background: '#EFF6FF',
              borderRadius: 12,
              padding: '14px 16px',
              marginBottom: 16,
              marginTop: 10,
              gap: 10,
            }}
          >
            <Col flex="none">
              <InfoCircleOutlined style={{ color: '#2563EB', fontSize: 18, marginTop: 2 }} />
            </Col>
            <Col flex="auto">
              <MyText
                color="#1D4ED8"
                size={14}
                weight={500}
                style={{ fontFamily: 'Nunito', display: 'block', lineHeight: '20px' }}
              >
                Вместе с вопросом специалисту будут автоматически отправлены результаты диагностики (если она пройдена) и таблица наблюдений за текущую неделю
              </MyText>
            </Col>
          </Row>
        )}

        <Form.Item style={{ textAlign: 'center', marginBottom: 8, marginTop: 8 }}>
          <MyButton
            color='orange'
            type='primary'
            htmlType="button"
            onClick={handleButtonClick}
            disabled={isButtonDisabled || isLoading }
          >
            {`${t("send")}`}
          </MyButton>
        </Form.Item>
      </Form>
      </>
    )}
    </Modal>
  );
};
